import React from 'react';
import { SchematicShell } from './SchematicPrimitives';

/**
 * Floating shelf elevation (pairs with dormFloatingShelfRenderer).
 *
 * The 3D object is a single clean plank plus a mounting rail recessed into
 * its BACK face. Front-on, the rail is hidden behind the plank, so the front
 * elevation is honestly just the plank outline — drawing a fake bracket would
 * show something the 3D view does not have.
 *
 * The side view is where the shelf reads as a shelf: the plank in section
 * with the rail against the wall, so the mounting depth is legible.
 */
const IN = 0.0254;
const RAIL_DEPTH = 0.15 * IN; // matches dormFloatingShelfRenderer

export function DormFloatingShelfSchematic({
  widthMeters: width,
  heightMeters: height,
  depthMeters: depth,
  view = 'front',
  strokeColor,
  strokeWidth,
}) {
  if (view === 'left' || view === 'right') {
    const railD = Math.min(RAIL_DEPTH, depth / 2);
    return (
      <SchematicShell
        width={depth}
        height={height}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      >
        {/* Mounting rail against the wall (back of the section) */}
        <rect
          x={0}
          y={0}
          width={railD}
          height={height}
          fill={strokeColor}
          fillOpacity={0.12}
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          vectorEffect="non-scaling-stroke"
        />
      </SchematicShell>
    );
  }

  return (
    <SchematicShell
      width={width}
      height={height}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
    />
  );
}

DormFloatingShelfSchematic.supportsSideViews = true;
